export const uiEn = {
  nav: {
    exploring: "Exploring",
    about: "About",
    education: "Education",
    experience: "Experience",
    research: "Research",
    gallery: "Gallery",
    journal: "Journal",
    contact: "Contact",
    cv: "CV",
  },
  hero: {
    portfolio: "Portfolio",
    greeting: "Hi, I'm",
    note: "that's me! →",
    begin: "Begin the story",
    downloadCv: "Download CV",
    scroll: "Scroll to explore",
    fig: "Fig. 01 — The observer of people",
    est: "Est. Hyderabad → Dortmund",
  },
  exploring: {
    chapter: "Currently Exploring",
    titleA: "A living page,",
    titleB: "always in progress",
    stamp: "Last updated · July 2026",
  },
  about: {
    chapter: "About Me",
    titleA: "A psychologist",
    titleB: "in training",
    titleC: "a storyteller by nature",
    note: "a little about me",
    photoCaption: "café thoughts, probably about people",
  },
  education: {
    chapter: "Education",
    titleA: "An education in",
    titleB: "two worlds",
    titleC: "— mind and market",
  },
  experience: {
    chapter: "Experience",
    titleA: "Not a list of duties —",
    titleB: "a record of becoming",
    learned: "What I learned",
    impact: "Impact",
  },
  research: {
    chapter: "Research & Projects",
    titleA: "The centerpiece —",
    titleB: "questions I've chased",
    intro: "Academic projects, clinical case work, and research in progress. Select a chapter to read the full study.",
    objective: "Objective",
    methodology: "Methodology",
    outcome: "Outcome",
    keyLesson: "Key lesson",
  },
  skills: {
    chapter: "Skills & Expertise",
    titleA: "A toolkit built",
    titleB: "across disciplines",
  },
  certificates: {
    chapter: "Certificates & Achievements",
    titleA: "Proof of",
    titleB: "curiosity",
    titleC: "formally recognized",
    achievements: "Achievements",
  },
  interests: {
    chapter: "Beyond Academics",
    titleA: "The person behind",
    titleB: "the transcripts",
    note: "outside the academic bubble",
    open: "Open page",
    intro: "Reading, photography, travel, journaling, coffee, design — the habits that keep the researcher human.",
  },
  beyond: {
    back: "Back to portfolio",
    fromJournal: "From the Journal — essays live here",
    emptyTitle: "Nothing here yet",
    emptyText: "This page is freshly pressed — entries are on their way.",
    categories: {
      reading: { name: "Reading", tagline: "books that explain people" },
      photography: { name: "Photography", tagline: "the award-winning habit of noticing" },
      traveling: { name: "Traveling", tagline: "cultures as field studies" },
      journaling: { name: "Journaling", tagline: "where thoughts become questions" },
      "coffee-culture": { name: "Coffee Culture", tagline: "every city, remembered in cafés" },
      growth: { name: "Personal Growth", tagline: "a lifelong pilot study" },
    },
  },
  gallery: {
    chapter: "Gallery",
    titleA: "An editorial",
    titleB: "photo journal",
    note: "little moments I kept",
    intro: "Travel, conferences, university life, and the everyday — selected frames from the field notes of a photographer at heart.",
  },
  resume: {
    chapter: "Résumé",
    titleA: "The",
    titleB: "one-page",
    titleC: "version",
    intro: "A condensed, printable record of my education, clinical experience, and skills — formatted for recruiters, professors, and the curious.",
    download: "Download CV — PDF",
    note: "the formal version, I promise",
    profile: "Profile",
    education: "Education",
    experience: "Experience",
    coreSkills: "Core Skills",
    profileText:
      "Dedicated psychology student with extensive clinical internship experience in paediatric, cognitive, and counselling settings. Skilled in psychometric assessment, evidence-based interventions, and cross-functional collaboration — committed to empathetic, data-driven outcomes.",
  },
  contact: {
    chapter: "Contact",
    titleA: "Let's start",
    titleB: "a conversation",
    intro:
      "Whether it's research collaboration, an internship opportunity, a question about I/O psychology, or simply a good book recommendation — my inbox is always open.",
    writeToMe: "Write to me",
    nameLabel: "Your name",
    emailLabel: "Your email",
    messageLabel: "Message",
    namePh: "Jane Doe",
    emailPh: "jane@example.com",
    messagePh: "Hello Sahithi, I came across your portfolio and…",
    send: "Send message",
    sending: "Sending…",
    toastSuccess: "Message sent — thank you for reaching out. I'll reply soon.",
    toastError: "Something went wrong — please email me directly instead.",
    emailSmall: "Email",
    phoneLabel: "Phone",
    connect: "Connect with me",
    basedIn: "Based in",
  },
  footer: {
    tagline: "Psychology & Management — Dortmund · Hyderabad · New York",
    backToTop: "Back to top",
    copyright: "© 2026 Sahithi Rasakonda. Written, designed, and photographed with curiosity.",
    quote: "“Evidence and empathy belong together.”",
  },
  journal: {
    back: "Back to portfolio",
    kicker: "The Journal",
    sub: "Occasional essays",
    titleA: "Notes on people,",
    titleB: "work, and wonder",
    intro: "Psychology, leadership, research, books, and travel — reflections from an academic journey still being written.",
    readEssay: "Read essay",
    read: "Read",
    allEssays: "All essays",
    notFound: "This essay seems to have wandered off.",
  },
};
